import React from 'react'
import { REFUND_URL, SHIPPING_URL, TERMS_AND_CONDITIONS_URL } from '../../app/constants'
import privacy from "../../../src/assets/docs/Privacy Policy.pdf"

const TermsAndConditions = () => {
    return (
        <div>
            <a className='ml-3 text-primary' style={{ textDecoration: 'underline' }} href={TERMS_AND_CONDITIONS_URL} rel={"no-refferrer noreferrer"} target='_blank'  >Terms & Conditions,</a>
            <a className='text-primary ml-1' style={{ textDecoration: 'underline' }} href={REFUND_URL} rel={"no-refferrer noreferrer"} target='_blank'  >Refund & Cancellation Policy, </a>
            <a className='ml-1 text-primary' style={{ textDecoration: 'underline' }} href={SHIPPING_URL} rel={"no-refferrer noreferrer"} target='_blank'  >Shipping Policy &</a>
            <a className='ml-1 text-primary' style={{ textDecoration: 'underline' }} href={privacy} rel={"no-refferrer noreferrer"} target='_blank'  >Privacy Policy</a>
        </div>
    )
}

export default TermsAndConditions
